<template>
  <div class="verification">
    <div class="form">
      <span v-if="checkVerificationTxt">{{ $t("main.verificationTxt") }}</span>
      <span v-else-if="isSuccess">{{ formText.success }}.</span>
      <span v-else="!isSuccess">{{ formText.error }}.</span>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
export default {
  data() {
    return {
      isSuccess: null,
      checkVerificationTxt: true
    };
  },
  computed: {
    formText() {
      return {
        success: this.$i18n.t("main.verificationSuccess"),
        error: this.$i18n.t("main.verificationError")
      };
    }
  },
  mounted() {
    this.checkVerification();
  },
  methods: {
    async checkVerification() {
      const params = {
        token: this.$route.query.token
      };
      try {
        const res = await api.verifyToken(params);
        this.isSuccess = res.data.res === "ok";
      } catch (err) {
        console.log(err.message);
      } finally {
        this.checkVerificationTxt = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.verification {
  min-height: 60vh;
  // height: 60vh;
  min-height: 400px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .form {
    border: 1px solid silver;
    padding: 30px 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px 10px;

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding-right: 20px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      max-width: 230px;
    }

    .btn {
      background: #e9786e;
      text-transform: uppercase;
      color: white;
      width: calc(50% - 7px);
      font-weight: bold;
      font-size: 10px;
      text-transform: none;

      &.disabled {
        opacity: 0.7;
      }
    }
  }
}
</style>
